import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Suspense } from 'react';
import { appConfig } from 'shared';
import { useMountedState } from '~/hooks/use-mounted-state';
import { AppFooterLinks, type FooterLinkProps } from '~/modules/common/app/app-footer';
import { Logo } from '~/modules/common/logo';
import { lazyNamed } from '~/utils/lazy-named';

const BgAnimation = lazyNamed(() => import('~/modules/common/bg-animation/bg-animation'), 'BgAnimation');

export function AuthLayout() {
  const { hasStarted, hasWaited } = useMountedState();
  const isSignInPage = useRouterState({ select: (s) => (s.resolvedLocation ?? s.location).pathname === '/auth/authenticate' });

  const authFooterLinks: FooterLinkProps[] = [{ id: 'about', href: appConfig.aboutUrl }];

  if (!isSignInPage) authFooterLinks.unshift({ id: 'sign_in', href: '/auth/authenticate' });

  return (
    <div
      data-started={hasStarted}
      data-waited={hasWaited}
      className="group rich-gradient container flex min-h-[90svh] flex-col items-center before:fixed after:fixed sm:min-h-svh"
    >
      <Suspense fallback={null}>
        <BgAnimation />
      </Suspense>

      <div className="mt-auto mb-auto">
        <div className="mx-auto mt-8 mb-40 flex w-[90vw] xs:w-80 translate-y-4 flex-col justify-center gap-4 opacity-0 transition-[opacity,transform] duration-500 ease-out will-change-transform has-[.error-notice]:w-[90vw] group-data-[started=false]:scale-95 group-data-[started=true]:opacity-100 sm:w-lg has-[.error-notice]:sm:w-200">
          <Outlet />

          <Link to="/about" className="focus-effect mx-auto rounded-md p-4 hover:opacity-90 active:scale-95">
            <Logo height={40} />
          </Link>

          <AppFooterLinks className="justify-center" links={authFooterLinks} />
        </div>
      </div>
    </div>
  );
}
